import { useEffect, useState } from "react";
import "../../css/Reports/headersection_report.css";
import "../../css/Reports/reportlistsection_report.css";
import "../../css/Reports/leftpanel_report.css";
import "../../css/Reports/rightpanel_report.css";
import ReportHeader from "./ReportHeader";
import ReportLeftPanel from "./ReportLeftPanel";
import ReportListSection from "./ReportListSection";
import ReportRightPanel from "./ReportRightPanel";
import { getReportListApi } from "../../api/reportApi";

export default function ReportPage() {
    const [reports, setReports] = useState([]);
    const [sidebarPinned, setSidebarPinned] = useState(true);
    const [sidebarHover, setSidebarHover] = useState(false);
    const [groupByOptions, setGroupByOptions] = useState([]);
    const [groupBySelected, setGroupBySelected] = useState([]);
    const [selectedReportPath, setSelectedReportPath] = useState("");
    const [reportType, setReportType] = useState("Summary");

    useEffect(() => {
        loadReports();
    }, []);

    const loadReports = async () => {
        const payload = { Report_ID: 1 };
        const res = await getReportListApi(payload);
        const data = res?.ReportList || [];
        const parents = data.filter(x => !x.ReportId);
        const children = data.filter(x => x.ReportId);
        const structured = parents.map(p => ({
            id: p.ReportGroupId,
            title: p.GroupTitle,
            children: children
                .filter(c => c.ReportId === p.ReportGroupId)
                .map(c => ({
                    name: c.GroupTitle,
                    groupByTag: c.GroupByTag
                }))
        }));

        setReports(structured);
    };

    const isCollapsed = !sidebarPinned && !sidebarHover;

    return (
        <div className="report-container">
            <ReportHeader selectedReportPath={selectedReportPath} />
            <div className={`report-body ${isCollapsed ? "sidebar-collapsed" : ""}`}>
                <ReportListSection
                    reports={reports}
                    sidebarPinned={sidebarPinned}
                    setSidebarPinned={setSidebarPinned}
                    setSidebarHover={setSidebarHover}
                    setGroupByOptions={setGroupByOptions}
                    setGroupBySelected={setGroupBySelected}
                    setSelectedReportPath={setSelectedReportPath}
                    setReportType={setReportType}
                />
                <ReportLeftPanel />
                <ReportRightPanel
                    groupByOptions={groupByOptions}
                    groupBySelected={groupBySelected}
                    setGroupBySelected={setGroupBySelected}
                />
            </div>
        </div>
    );
}